import { Button, Grid } from '@mui/material';
import { FixedButton } from '@/components/common/button/FixedButton';
import { LoadingButton } from '@/components/common/button/LoadingButton';
import { MobileBar } from '@/components/home/MobileBar';
import { PhoneVerificationFlow } from '@/components/common/phone/usePhoneVerificationFlow';
import { SMS_MESSAGE_CONFIRM_CODE, SMS_MESSAGE_NEXT_STEP } from '@/utils/phone-utils';
import { Theme } from '@mui/material/styles';
import ChevronLeftIcon from '@mui/icons-material/ChevronLeft';
import React, { FC, ReactElement } from 'react';

interface Props {
  flow: PhoneVerificationFlow;
  isMobile?: boolean;
  onBack: () => void;
}

/**
 * Back and forward for the number-entry and SMS-code steps.

 * @param props The flow state, the viewport and what stepping back should do.
 */
export const PhoneVerificationActions: FC<Props> = (props: Props): ReactElement => {
  const { flow, isMobile, onBack } = props;

  const submitLabel: string = flow.step === 'code' ? SMS_MESSAGE_CONFIRM_CODE : SMS_MESSAGE_NEXT_STEP;

  return (
    <Grid container={true} spacing={2} pb={isMobile ? 7 : 0}>
      <Grid item={true} xs={12} sm={6}>
        <Button
          sx={{ padding: (theme: Theme) => theme.spacing(1.375, 1) }}
          fullWidth={true}
          variant={'outlined'}
          onClick={onBack}
          data-testid={'phone-verification-back'}
          startIcon={<ChevronLeftIcon sx={{ display: 'block' }} />}>
          {'Назад'}
        </Button>
      </Grid>
      {isMobile ? (
        <MobileBar>
          <FixedButton color={'primary'} variant={'contained'} onClick={flow.submit} disabled={flow.isLoading}>
            {submitLabel}
          </FixedButton>
        </MobileBar>
      ) : (
        <Grid item={true} xs={6}>
          <LoadingButton fullWidth={true} isLoading={flow.isLoading} variant={'contained'} onClick={flow.submit}>
            {submitLabel}
          </LoadingButton>
        </Grid>
      )}
    </Grid>
  );
};
